export default __webpack_public_path__ + "static/media/1492509316_game_center_ios7_ios_7.0e609035.png";